<template>
  <div
      class="orm-mb-16 orm-col-xs-12 orm-col-sm-8 orm-col-md-6 orm-col-lg-4 orm-px-xs-8"
      v-if="filter"
      :rel="JSON.parse(JSON.stringify(car.toString()))"
  >
    <div
        class="orm-caroffers__element"
        :class="isOffer ? 'orm-caroffers__element--offer' : ''"
    >
      <div class="orm-slider__image__container">
        <Slider v-if="images" :images="images" :autoplay="true" />
        <div v-else :style="{ paddingTop: '75%' }"></div>
      </div>

      <div class="orm-cartitle">
        <h2 class="orm-headline__h2">
          {{ stripHTML(data[env.VUE_APP_RESERVATION_CARGROUP]) }}
        </h2>
        <p class="orm-headline__h2__subheadline orm-relative">
          {{ stripHTML(data[env.VUE_APP_RESERVATION_CARCATEGORY]) }}
          <i class="fal fa-question-circle orm-cargroup__tooltip"
          ><span
              class="orm-cargroup__tooltip_text orm-cargroup__tooltip-bottom"
          >{{ i18n("cargroup/noguarantee") }}</span
          ></i
          >
        </p>
        <div
            v-if="
            store.getters['ORMgeneral/GET_PARAMETER'](
              'BORMLF_STEP1_SHOW_ADD_TEXT'
            ) == '1'
          "
            v-html="data[env.VUE_APP_RESERVATION_CARTEXT]"
        ></div>
      </div>
      <div v-if="!loading">
        <div class="orm-cardetails" v-if="price.length > 0">
          <div class="orm-carequip">
            <p class="orm-equip__txt__icons">
              <equipIcon :data="data.features" :shortlist="true" />
            </p>
            <p class="orm-equip__txt__freemiles">
              <span v-if="price && !price[0].all_km_inclusive"
              >{{ i18n("cargroup/inclusive") }} {{ price[0].km_free }}
                {{ i18n("cargroup/freeKilometers") }}</span
              >
              <span v-else
              >{{ i18n("cargroup/inclusive") }}
                {{ i18n("cargroup/unlimited") }}
                {{ i18n("cargroup/freeKilometers") }}</span
              >
            </p>
          </div>

          <div class="orm-carprice" v-if="price.length > 0 && !loading">
            <div v-if="priceData">
              <p class="orm-price__txt__surtitle">
                {{ priceData.main.label }}
              </p>
              <p class="orm-price__txt" :class="{ 'orm-price__txt--offer': isOffer }">
                <span style="white-space: nowrap">
                  {{ formatPrice(priceData.main.value) }}
                </span>
              </p>
              <p v-if="priceData.sub.text" class="orm-price__txt__subtitle">
                {{ priceData.sub.text }}
              </p>
            </div>
          </div>
        </div>
        <div class="orm-carbutton">
          <button
              v-if="price.length > 0 && !loading"
              @click="setCarGroup(car)"
              class="orm-button__cta small"
              :class="isOffer ? 'orm-button__cta--offer' : 'outline'"
          >
            {{
              isOffer
                  ? i18n("cargroup/select_offer") || "Angebot sichern"
                  : i18n("cargroup/select")
            }}<i
              v-if="isOffer"
              class="orm-button__cta--offer-icon far fa-stars"
          ></i>
          </button>
          <div class="orm-car__error" v-if="price.length == 0 && !loading">
            <button
                class="orm-button__cta outline small"
                @click="openContactModal(car)"
            >
              {{ i18n("cargroup/error/button") }}
            </button>
            {{ i18n("cargroup/error/price") }}
          </div>
        </div>
      </div>
      <div class="orm-price__txt text-center orm-mb-32 orm-mt-32" v-else>
        <i class="fa fa-spinner-third orm-rotate360"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store";
import equipIcon from "@/components/reservation/equip-icon.vue";
import Slider from "@/components/ui/image-slider.vue";
import { convertCurrency } from "@/constants/formater";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";

export default defineComponent({
  name: "car-list-small",
  components: { equipIcon, Slider },
  mixins: [i18n, stripHTML],
  setup() {
    const userSession = store.state.userSession.LocalSession;
    return {
      userSession,
      store,
      convertCurrency,
      routeToSteps,
    };
  },
  data() {
    return {
      car: Object,
      price: [],
      isOffer: false,
      images: null,
      show: true,
      loading: true,
      tarif: Object,
      env: process.env,
      switchTotalLongPricePosition: false,
      showNettoPrice: false,
      roundPrices: false,
      showDaysOnly: false,
      showTotalPriceOnly: false,
    };
  },
  props: {
    data: Object,
    filter: Boolean,
  },
  async mounted() {
    const showNetto = await store.getters["ORMgeneral/GET_PARAMETER"](
        "BORM_SHOW_NETTO_PRICE"
    );
    if (showNetto === "1") this.showNettoPrice = true;

    const pricePosition = await store.getters["ORMgeneral/GET_PARAMETER"](
        "BORM_GESAMTPREIS_FETT"
    );
    if (pricePosition === "1") this.switchTotalLongPricePosition = true;

    const roundPricesParam = await store.getters["ORMgeneral/GET_PARAMETER"](
        "ORM_STEP2_PREISE_RUNDEN"
    );
    if (roundPricesParam === "1") this.roundPrices = true;

    const showDaysOnlyParam = await store.getters["ORMgeneral/GET_PARAMETER"](
        "ORM_STEP2_SHOW_DAYS_ONLY"
    );
    if (showDaysOnlyParam === "1") this.showDaysOnly = true;

    const showTotalPriceOnlyParam = await store.getters["ORMgeneral/GET_PARAMETER"](
        "BORMLF_STEP1_SHOW_TOTALPRICE_ONLY"
    );
    if (showTotalPriceOnlyParam === "1") this.showTotalPriceOnly = true;

    this.car = await JSON.parse(JSON.stringify(this.data));
    this.car.price = {};

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      observer.unobserve(this.$el);
      this.lazyload();
    });
    observer.observe(this.$el);
  },
  emits: ["openContact"],
  computed: {
    rentalDurationInDays() {
      try {
        const startDateStr = store.getters["userSession/GET_RESERVATIONDATE_START"];
        const startTimeStr = store.getters["userSession/GET_RESERVATIONTIME_START"];
        const endDateStr = store.getters["userSession/GET_RESERVATIONDATE_END"];
        const endTimeStr = store.getters["userSession/GET_RESERVATIONTIME_END"];
        if (!startDateStr || !startTimeStr || !endDateStr || !endTimeStr) return 1;
        const startDate = new Date(`${startDateStr}T${startTimeStr}`);
        const endDate = new Date(`${endDateStr}T${endTimeStr}`);
        const differenceInMs = endDate.getTime() - startDate.getTime();
        const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));
        return differenceInDays > 0 ? differenceInDays : 1;
      } catch (error) {
        console.error("Fehler bei der Berechnung der Mietdauer:", error);
        return 1;
      }
    },
    priceData() {
      const totalPrice = this.showNettoPrice ? this.tarif?.end_positions?.[0]?.total_price : this.tarif?.total_price_main_rates;
      const apiUnitPrice = this.showNettoPrice ? this.price?.[0]?.single_price : this.price?.[0]?.long_price;
      const totalLabel = this.i18n("cargroup/total");
      const unitLabel = `${this.i18n("cargroup/unitbefore")} ${this.price?.[0]?.unit} ${this.i18n("cargroup/unitafter")}`;
      const perDayLabel = this.i18n("cargroup/perday") || "pro Tag";

      if (this.showTotalPriceOnly) {
        return { main: { value: totalPrice, label: totalLabel }, sub: { text: "" } };
      }
      if (this.showDaysOnly) {
        const calculatedDailyPrice = (totalPrice && this.rentalDurationInDays) ? totalPrice / this.rentalDurationInDays : apiUnitPrice;
        return { main: { value: calculatedDailyPrice, label: perDayLabel }, sub: { text: `(${totalLabel}: ${this.formatPrice(totalPrice)})` } };
      }
      if (this.switchTotalLongPricePosition) {
        return { main: { value: totalPrice, label: totalLabel }, sub: { text: `${unitLabel}: ${this.formatPrice(apiUnitPrice)}` } };
      }
      return { main: { value: apiUnitPrice, label: unitLabel }, sub: { text: `(${totalLabel}: ${this.formatPrice(totalPrice)})` } };
    },
  },
  methods: {
    formatPrice(value) {
      let priceToFormat = Number(value) || 0;
      if (this.roundPrices) {
        priceToFormat = Math.round(priceToFormat);
      }
      return this.convertCurrency(priceToFormat);
    },
    async lazyload() {
      const car = [];
      this.images = this.car.images;
      this.tarif = await store
          .dispatch("reservation/CALCULATE_PRICE", { id: this.car.id, extras: false })
          .then((res) => {
            if (!res.errors) {
              res.main_rates.forEach((element) => {
                if (element.position == 1) {
                  car.push(element);
                  if (element.is_offer) this.isOffer = true;
                }
              });
              this.loading = false;
              return res;
            } else {
              this.loading = false;
              this.$emit("update:error", res);
            }
          });
      this.price = car;
    },
    setCarGroup(car) {
      store.dispatch("userSession/SET_CARGROUP", car.id).then(() => {
        store.dispatch("reservation/SET_RESERVATION_TARIFS", this.tarif).then(() => {
          if (this.isOffer) buildDataLayer("view_promotion", {}, null);
          routeToSteps(this, 2);
        });
      });
    },
    openContactModal(car) {
      this.$emit("openContact", car);
    },
  },
});
</script>